// @flow
import * as React from 'react';
import styled from 'styled-components';
import {LocalizedParagraph, type LocalizedText} from 'components/Localized';
import {BackgroundImage} from 'components/Image';

type Props = {
  title: LocalizedText,
  datarect?: DOMRect | Object,
  datax?: number,
  datay?: number,
}

export function GuideLinePointRT(props: Props): React.Element<any> {
  return (
    <GuidePoint source="./driving-zone/b/line-guide-click-here.png">
      <LocalizedParagraph {...props.title} />
    </GuidePoint>
  )
}

export function GuideLinePointLT(props: Props): React.Element<any> {
  return (
    <GuidePoint2 source="./driving-zone/b/line-guide-click-here-left.png" datarect={props.datarect} datax={props.datax} datay={props.datay}>
      <LocalizedParagraph {...props.title} />
    </GuidePoint2>
  )
}

const GuidePoint = styled(BackgroundImage)`
  position: absolute;
  right: ${(props) => props.theme.layout.scale * (props.theme.layout.mobile ? 40 : 98)}px;
  top: ${(props) => props.theme.layout.scale * (props.theme.layout.mobile ? 27 : 54)}px;

  background-repeat: no-repeat;
  background-position: right top;
  background-size: contain;
  padding-right: ${(props) => (props.theme.layout.mobile ? 39 : 77)}px;
  padding-top: ${(props) => (props.theme.layout.mobile ? 38 : 76)}px;
  p {
    position: absolute;
    right: ${(props) => (props.theme.layout.mobile ? 39 : 77)}px;
    top: ${(props) => (props.theme.layout.mobile ? 38 : 76)}px;
    white-space: nowrap;
  }
`;

const GuidePoint2 = styled(BackgroundImage)`
  position: absolute;
  left: ${(props) => props.datarect.x + props.datarect.width * (props.datax ?? 0.5)}px;
  top: ${(props) => props.datarect.y + props.datarect.height * (props.datay ?? 0.5)}px;
  visibility: ${(props) => (props.datarect.x === undefined || props.datarect.width === 0 ? 'hidden' : 'visible')};

  background-repeat: no-repeat;
  background-position: left top;
  background-size: ${(props) => (props.theme.layout.mobile ? 38 : 76)}px
    ${(props) => (props.theme.layout.mobile ? 39 : 77)}px;
  padding-top: ${(props) => (props.theme.layout.mobile ? 38 : 76)}px;
  padding-left: ${(props) => (props.theme.layout.mobile ? 39 : 77)}px;

  > p {
    text-align: left;
  }
`;
